export const API_FACEBOOK = 'https://graph.facebook.com';
export const API_VERSION = 'v22.0';
export const ENDPOINT_TOKEN = 'oauth/access_token';
export const GRANT_TYPE = 'fb_exchange_token';
export const SRC_CONNECT = 'https://connect.facebook.net/en_US/sdk.js';
export const ENDPOINT_ADS = 'me/adaccounts';
export const ENDPOINT_WSP_BUSINESS = 'me';
export const LIMIT_ADS = 500;
